export default __webpack_public_path__ + "static/filehard-270e218ced46a8f9b4818a5a6378ae4e.png";